export { PrepareEmbed };
window.PrepareEmbed = PrepareEmbed;
function PrepareEmbed(template) {
   return function (data) {
      let element = $(template(data));

      // Add target="_parent" to all links in the embed
      element.find('a:not(.no-blank)').attr('target', '_blank');

      element
         .find('.js-nav-button')
         .attr('title', _js('Hint: You can use left/right arrow keys to navigate the guide!'));

      let siteName = $('html').data('site');

      if (siteName != 'ifixit') {
         element.find('.js-hide-ifixit').remove();
      }

      return element;
   };
}
